export default __webpack_public_path__ + "static/media/error.b4b06fd4.svg";